import { FertilizationBalanceSetting, LabResultReceiveDates, SpecificReferenceBlock } from 'src/app/shared/models';

export class EditFertilizationBalanceSettingsDialogHelper {

  static isSpecificReferenceBlockLocked(setting: FertilizationBalanceSetting): boolean {
    return !!setting.isPlantDateConfirmed;
  }

  static hasSpecificReferenceBlockData(block?: SpecificReferenceBlock): boolean {
    if (!block) {
      return false;
    }

    const hasCoordinates = this.hasGpsCoordinates(block);
    const hasRemarks = !!block.remarks?.trim();

    return hasCoordinates || hasRemarks;
  }

  static hasGpsCoordinates(block?: SpecificReferenceBlock): boolean {
    return block?.longitude != null && block.latitude != null;
  }

  static hasLabResultReceiveDates(labResultReceiveDates?: LabResultReceiveDates): boolean {
    if (!labResultReceiveDates) {
      return false;
    }
    return !!(
      labResultReceiveDates.n1ReceivedDateUtcB ||
      labResultReceiveDates.n2ReceivedDateUtcP ||
      labResultReceiveDates.n3ReceivedDateUtcB ||
      labResultReceiveDates.n3ReceivedDateUtcP
    );
  }
}
